import _ from 'lodash';
import React, { Component } from 'react';

import { TodoList } from '../../shared';

import {
  getCurrentTime,
} from '../../../util';

class ActionItems extends Component {

  addActionItem(newActionItemText){
    const updatedDeal = {
      ...this.props.deal,
      actionItems: [
        ...(this.props.deal.actionItems || []),
        {
          text: newActionItemText,
          completed: false,
        }
      ]
    }

    this.props.updateDeal(updatedDeal, deal => {
      console.log('deal updated!');
    });
  }
  completeActionItem(actionItem){

    let actionItemsToUpdate = this.props.deal.actionItems;

    const actionItemIndex = _.indexOf(actionItemsToUpdate, actionItem);

    const completedActionItem = {
      ...actionItem,
      completed: true,
      completedOn: getCurrentTime()
    }

    actionItemsToUpdate[actionItemIndex] = completedActionItem;

    const updatedDeal = {
      ...this.props.deal,
      actionItems: actionItemsToUpdate
    }

    this.props.updateDeal(updatedDeal, deal => {
      console.log('deal updated!');
    });

  }

  uncompleteActionItem(actionItem){

    let actionItemsToUpdate = this.props.deal.actionItems;

    const actionItemIndex = _.indexOf(actionItemsToUpdate, actionItem);

    const uncompletedActionItem = {
      text: actionItem.text,
      completed: false,
    }

    actionItemsToUpdate[actionItemIndex] = uncompletedActionItem;

    const updatedDeal = {
      ...this.props.deal,
      actionItems: actionItemsToUpdate
    }

    this.props.updateDeal(updatedDeal, deal => {
      console.log('deal updated!');
    });

  }

  deleteActionItem(actionItem){
    let actionItemsToUpdate = [ ...this.props.deal.actionItems ];

    const actionItemIndex = _.indexOf(actionItemsToUpdate, actionItem);

    actionItemsToUpdate.splice(actionItemIndex, 1);

    const updatedDeal = {
      ...this.props.deal,
      actionItems: actionItemsToUpdate
    }

    this.props.updateDeal(updatedDeal, deal => {
      console.log('deal updated!');
    });
  }

  render(){
    return(
      <TodoList
        addItem={item => { this.addActionItem(item); }}
        secondaryAction={this.props.secondaryAction}
        completeItem={this.completeActionItem.bind(this)}
        uncompleteItem={this.uncompleteActionItem.bind(this)}
        deleteItem={this.deleteActionItem.bind(this)}
        className="action-item-todos"
        newItemLabel={'New Action Item'}
        items={this.props.actionItems}
      />
    )
  }
}

export default ActionItems;



// WEBPACK FOOTER //
// ./src/components/imperatives/deal/actionItems.js